import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle,
  GenericRequirementNotificationContext
} from "./helper";

export const RequirementsCompletePayee: NotificationAlertOverride<
  GenericRequirementNotificationContext
> = (notification, history) => {
  return {
    theme: "success",
    icon: "check-circle",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsCompletePayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsCompletePayee
    ),
    action: createRequirementAction(notification, history)
  };
};
